__turbopack_context__.v({
  "badge": "AuRetailSaleModal-module___ic8FW__badge",
  "buyNow": "AuRetailSaleModal-module___ic8FW__buyNow",
  "close": "AuRetailSaleModal-module___ic8FW__close",
  "description": "AuRetailSaleModal-module___ic8FW__description",
  "dialog": "AuRetailSaleModal-module___ic8FW__dialog",
  "finePrint": "AuRetailSaleModal-module___ic8FW__finePrint",
  "header": "AuRetailSaleModal-module___ic8FW__header",
  "overlay": "AuRetailSaleModal-module___ic8FW__overlay",
  "retailerLink": "AuRetailSaleModal-module___ic8FW__retailerLink",
  "retailerLogo": "AuRetailSaleModal-module___ic8FW__retailerLogo",
  "retailerName": "AuRetailSaleModal-module___ic8FW__retailerName",
  "retailers": "AuRetailSaleModal-module___ic8FW__retailers",
  "title": "AuRetailSaleModal-module___ic8FW__title",
});
